<template>
  <div
    class="mapping-item"
    :class="{ 'is-hover': isHovered, 'is-selected': selected }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    @click.stop="handleClick"
  >
    <div class = "mapping-item-top-row">
      <span class="mapping-label">{{`• ${label}`}}</span>
      <span v-if="isLoading" class="loading-indicator">
        <svg class="spinner" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#1E4670" stroke-width="3" stroke-linecap="round" stroke-dasharray="31.4 31.4" stroke-dashoffset="0">
            <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
          </circle>
        </svg>
        <span class="loading-text">AI mapping...</span>
      </span>
      <!-- Original: 
      <ActionButton
        v-if="!isLoading"
        text="Clear Mapping"
        default-color="#374957"
        hover-text-color="#1E4670"
        pressed-text-color="#1E4670"
        hover-bg-color="rgba(30, 70, 112, 0.08)"
        pressed-bg-color="rgba(30, 70, 112, 0.12)"
        @click.stop="handleClearSelector"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M10.7925 8.29885L12 9.50635V8.29885H10.7925ZM12.75 5.29885H9.75V6.72385H12.75C14.0325 6.72385 15.075 7.76635 15.075 9.04885C15.075 10.0013 14.4975 10.8263 13.6725 11.1788L14.7225 12.2288C15.7875 11.5688 16.5 10.3913 16.5 9.04885C16.5 6.97885 14.82 5.29885 12.75 5.29885ZM1.5 3.25135L3.8325 5.58385C2.4675 6.13885 1.5 7.48135 1.5 9.04885C1.5 11.1188 3.18 12.7988 5.25 12.7988H8.25V11.3738H5.25C3.9675 11.3738 2.925 10.3313 2.925 9.04885C2.925 7.85635 3.8325 6.87385 4.995 6.74635L6.5475 8.29885H6V9.79885H8.0475L9.75 11.5013V12.7988H11.0475L14.055 15.8063L15.1125 14.7488L2.5575 2.19385L1.5 3.25135Z" fill="#374957"/>
          </svg>
        </template>
      </ActionButton>
      -->
      <FoldableButton
        v-if="!isLoading"
        text="Clear Mapping"
        built_in_theme="default"
        @click.stop="handleClearSelector"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M10.7925 8.29885L12 9.50635V8.29885H10.7925ZM12.75 5.29885H9.75V6.72385H12.75C14.0325 6.72385 15.075 7.76635 15.075 9.04885C15.075 10.0013 14.4975 10.8263 13.6725 11.1788L14.7225 12.2288C15.7875 11.5688 16.5 10.3913 16.5 9.04885C16.5 6.97885 14.82 5.29885 12.75 5.29885ZM1.5 3.25135L3.8325 5.58385C2.4675 6.13885 1.5 7.48135 1.5 9.04885C1.5 11.1188 3.18 12.7988 5.25 12.7988H8.25V11.3738H5.25C3.9675 11.3738 2.925 10.3313 2.925 9.04885C2.925 7.85635 3.8325 6.87385 4.995 6.74635L6.5475 8.29885H6V9.79885H8.0475L9.75 11.5013V12.7988H11.0475L14.055 15.8063L15.1125 14.7488L2.5575 2.19385L1.5 3.25135Z" fill="#374957"/>
          </svg>
        </template>
      </FoldableButton>
      <!-- Original: 
      <ActionButton
        v-if="!isLoading"
        text="Delete"
        default-color="#D10000"
        hover-text-color="#F63B3B"
        pressed-text-color="#A60B0B"
        hover-bg-color="rgba(209, 0, 0, 0.08)"
        pressed-bg-color="rgba(209, 0, 0, 0.12)"
        @click.stop="$emit('delete', id)"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
          </svg>
        </template>
      </ActionButton>
      -->
      <FoldableButton
        v-if="!isLoading"
        text="Delete"
        built_in_theme="red"
        @click.stop="$emit('delete', id)"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
          </svg>
        </template>
      </FoldableButton>
    </div>
    <div class="mapping-selector" :class="{ 'is-disabled': isLoading }" @click="handleClickSelector">
      <SingleSelectorWithSectionalDropdown
        v-model:current-element-type="selectedMapping"
        :categories="mappingOptions"
        :disabled="isLoading"
        placeholder="No mapping selected"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// Original: import ActionButton from '@/views/commonComponents/ActionButton.vue';
// Replaced with globally registered FoldableButton from @vibrant-wellness/va-responsive-components-library
import SingleSelectorWithSectionalDropdown from '@/views/commonComponents/SingleSelectorWithSectionalDropdown.vue';

export default {
  name: 'MappingItem',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    mapping: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // ActionButton, // replaced by globally registered FoldableButton
    SingleSelectorWithSectionalDropdown
  },
  emits: ['select', 'deselect', 'mapping-changed', 'delete'],
  data() {
    return {
      isHovered: false,
      selectedMapping: this.mapping || ''
    };
  },
  computed: {
    ...mapGetters('workbench/formBuilder', ['getMappingOptionsForType']),
    
    /**
     * Dynamically get mapping options based on this element's type
     * Uses store getter to filter variables by allowed_field_types
     * Filters out mappings already used by other elements
     */
    mappingOptions() {
      // Pass element ID to filter out mappings used by other elements
      const variables = this.getMappingOptionsForType(this.type, this.id);
      
      if (!variables || variables.length === 0) {
        return [];
      }
      
      // Group variables by category for the sectional dropdown
      const categoriesMap = {};
      variables.forEach(variable => {
        const category = variable.category || 'Other';
        if (!categoriesMap[category]) {
          categoriesMap[category] = {
            name: category,
            label: category,
            elements: []
          };
        }
        categoriesMap[category].elements.push({
          type: variable.key,
          label: variable.display_label
        });
      });
      
      return Object.values(categoriesMap);
    }
  },
  methods: {
    handleClick() {
      if (!this.selected) {
        this.$emit('select', {
          id: this.id,
          type: this.type,
          label: this.label
        });
      } else {
        this.$emit('deselect', {
          id: this.id,
          type: this.type,
          label: this.label
        });
      }
    },
    handleMappingChange(element) {
      this.selectedMapping = element.type;
    },
    handleClearSelector() {
      this.selectedMapping = '';  // This will trigger watch and emit empty mapping
    },
    handleClickSelector(e) {
      if(this.selected){
        e.stopPropagation();
      }
    }
  },
  watch: {
    mapping(newValue) {
      this.selectedMapping = newValue || '';
    },
    selectedMapping(newValue) {
      this.$emit('mapping-changed', {
        id: this.id,
        mapping: newValue
      });
    }
  }
};
</script>

<style scoped>
.mapping-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 8px 12px 8px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #C4C4C4;
  cursor: pointer;
  transition: all 0.15s ease;
  width: 100%;
  position: relative;
}

.mapping-item:hover{
  border-color: #004879;
}
.mapping-item.is-selected{
  border-color: transparent;
}
.mapping-item.is-selected::after{
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width:4px;
  height:100%;
  background-color: #004879;
  border-radius: 4px 0 0 4px;
}

.mapping-item-top-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.mapping-label {
  padding-left: 8px;
  flex: 1;
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  white-space: pre-wrap;
  word-break: break-all;
}

.mapping-selector {
  width: 100%;
}
.mapping-selector.is-disabled {
  opacity: 0.5;
  pointer-events: none;
}
.mapping-selector :deep(.dropdown-list){
  z-index: 10001;
}
:deep(.element-type-selector) {
  width: 100%;
  min-width: fit-content;
}
:deep(.selector-trigger){
  min-width: 200px;
  width: 100% !important;
}
:deep(.dropdown-list){
  min-width: 200px;
  width: 100% !important;
}

.loading-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1E4670;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.spinner {
  width: 18px;
  height: 18px;
}

.loading-text {
  white-space: nowrap;
}
</style>
